export const LANGUAGES = [
    "javascript",
    "cpp",
    "python"
]

export const DEFAULT_LANGUAGE = "python"

export const LANGUAGE_COMMENT = {
    javascript: "// some comment",
    cpp: "// some comment",
    python: "# some comment"
}